module.exports = __webpack_public_path__ + "img/balavoine.14a04313.jpg";